<template>
  <v-layout column wrap  style="overflow-y: auto;">
    <v-toolbar dark class="toolbarcreatedadmin" style="margin-top: 20px;">
      <img :src="BASE_URL + 'static/icon/user.svg'" alt="" width="40px"> 
      &nbsp;&nbsp;
      <v-toolbar-title>ข้อมูล User</v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="hidden-sm-and-down">
        <v-text-field
          hide-details
          solo
          v-model="search"
          append-icon="search"
          label="ชื่อ, หมายเลขโทรศัพท์ และอีเมล"
          class="textfieldSearch"
        ></v-text-field>
         <v-select
          :items="itemsselect"
          v-model="selectKey"
          item-text="text"
          item-value="value"
          solo
          hide-details
          ligth
          class="textfieldSelect"
        ></v-select>
      </div>
    </v-toolbar>

    <div class="hidden-md-and-up">
        <v-text-field
          hide-details
          solo
          v-model="search"
          append-icon="search"
          label="ชื่อ, หมายเลขโทรศัพท์ และอีเมล"
          class="textfieldSearch"
        ></v-text-field>
         <v-select
          :items="itemsselect"
          v-model="selectKey"
          item-text="text"
          item-value="value"
          solo
          hide-details
          ligth
          class="textfieldSelect"
        ></v-select>
      </div>


    <v-layout row wrap justify-center align-center style="margin-top: 20px;">
      <v-data-table
        :headers="headers"
        :items="listGenerate"
        :items-per-page="10"
        class="elevation-1"
        @click:row="selectedDetailAdmin"
        style="cursor: pointer;"
      >
      <template v-slot:item.name="{ item }">
        {{name(item.first_name,item.last_name)}}
        <v-chip class="ma-2" small v-if="item.role !=='user'"> {{item.role}} </v-chip>
      </template> 
      <template v-slot:item.create_at="{ item }">
        {{ dateMoment(item.create_at)}} - {{ timeMoment(item.create_at)}}น.
      </template>
    </v-data-table>
    </v-layout>
  </v-layout>
</template>
<script>
import { Decode, Momenttime } from '@/services'
var _ = require('lodash')
export default {
  data () {
    return {
    BASE_URL: process.env.BASE_URL,
    items: [],
    selectKey: 'user',
    itemsselect: [
      { text: 'ผู้ใช้งานทั่วไป (รวมอาสาสมัคร)', value: 'user' },
      { text: 'ผู้ใช้งานทั่วไป (ไม่รวมอาสาสมัคร)', value: 'userNoVolun' },
      { text: 'Run for AED', value: 'runner' },
      { text: 'Hero CPR', value: 'cpr' },
      // { text: 'ตัวแทนบริษัทเจ้าของเครื่องAED', value: 'company' },
      // { text: 'ตัวแทนบริษัทบำรุงเครื่องAED', value: 'maintenance' },
      // { text: 'ทั้งหมด', value: 'all' }
    ],
    search: '',
    headers: [
      { text: 'ชื่อ-นามสกุล', value: 'name' },
      { text: 'หมายเลขโทรศัพท์', value: 'phone'},
      { text: 'อีเมล', value: 'email' },
      { text: 'วันเวลาที่ลงทะเบียน', value: 'create_at' }
    ],
    listUser: [],
    authen: {},
    headerAPI: {}
  }},
  created () {
    var decode = Decode.decode(localStorage.getItem('key'))
    this.authen = JSON.parse(decode)
    this.headerAPI = {Authorization: this.authen.Authorization}
    this.getlistUser()
    if (this.$route.query.type == 'user' || this.$route.query.type == 'userNoVolun' || this.$route.query.type == 'runner' || this.$route.query.type == 'cpr') {
      this.selectKey = this.$route.query.type
    }
  },
  computed: {
    listGenerate () {
      if (this.search !== '' && this.search !== null) {
        return this.listUserMode.filter(post => {
          // console.log(post.email.toLowerCase().includes(this.search.toLowerCase()))
          try {
            return post.first_name.toLowerCase().includes(this.search.toLowerCase()) || post.last_name.toLowerCase().includes(this.search.toLowerCase()) || post.phone.toLowerCase().includes(this.search.toLowerCase()) || post.email.toString().toLowerCase().includes(this.search.toLowerCase())
          } catch(err) {
          }
          
        })
      } else {
        return this.listUserMode
      }
    },
    listUserMode () {
      // if (this.selectKey == 'all') {
      //   return this.listUser
      // } else 
      if (this.selectKey == 'user') {
        return this.listUser.filter(post => { return post.role.toLowerCase().includes('user')})
      } else if (this.selectKey == 'userNoVolun') {
        return this.listUser.filter(post => { return post.role.toLowerCase().includes('user') && post.is_runner === false && post.is_cpr === false })
      } else if (this.selectKey == 'runner') {
        return this.listUser.filter(post => { return post.is_runner === true })
      } else if (this.selectKey == 'cpr') {
        return this.listUser.filter(post => { return post.is_cpr === true })
      } else if (this.selectKey == 'company') {
        return this.listUser.filter(post => { return post.role === 'admin' || post.role === 'superadmin' })
      } else if (this.selectKey == 'maintenance') {
        return this.listUser.filter(post => { return post.role === 'maintenance' })
      } else {
        return this.listUser
      }
    }
  },
  methods: {
    dateMoment(data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment(data) {
      return Momenttime.momenttimethai(data)
    },
    name (first,last) {
      if (first == null && last == null) {
        return '-'
      } else {
        return first + ' ' + last
      }
    },
    selectedDetailAdmin (item, row) {
      this.$router.push('/information_user?id='+item.userid)
    },
    getlistUser () {
      this.axios.get(process.env.API_BACKEND + '/v1/getAllUser', {headers: this.headerAPI}).then((response) => {
          this.listUser = response.data.data
          this.listUser = _.sortBy(this.listUser, function(dateObj) {
            return new Date(dateObj.create_at)
          }).reverse()
      })

    }
    
  }
}
</script>
<style media="screen" scoped>
/* >>>.v-textarea.v-text-field--full-width .v-text-field__slot .textarea {
  margin-top: 10px !important;
} */
>>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
}
.inputinfor_address {
  height: 110px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor_dis {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: #FAF0F0 !important;
}
>>>.theme--dark.v-select .v-select__selections {
    color: #a80e00 !important;
}
>>>.theme--dark.v-label {
    color: hsl(5, 100%, 33%) !important;
}
>>>.theme--dark.v-icon {
    color: #a80e00 !important;
}
>>>.theme--dark.v-input:not(.v-input--is-disabled) input {
  color: #a80e00 !important;
}
>>>.v-select__selections {
  line-height: 26px !important;
}
>>>.v-select__selection--comma {
  color: #a80e00 !important;
}
>>>.v-input .v-label {
    height: 26px;
    line-height: 26px;
  }
>>>.v-list-item__title {
    line-height: 26px !important;
}
.toolbarcreatedadmin {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-width: thin !important;
  box-shadow: none !important;
}

/* >>>.v-input__slot {
  border-radius: 10px !important;
  border-style: solid !important;
  border-width: thin !important;
  border-color: #a80f00 !important;
  background-color: #a80d0021 !important;
} */
.btngen {
  background-color: white !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
  width: 120px !important;
}
.btncreateuser {
  background-color: #a80f00 !important;
  color: #fafafa !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
}
.btncreateuser:disabled {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}

.btncancle {
  background-color: #fafafa !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  width: 160px !important;
}
.genpdf {
    cursor: pointer;  
  }
  .genpdf:hover {
    color: #a80d00;  
    text-decoration: underline;
  }
>>>.theme--light.v-data-table thead tr:last-child th {
    border-bottom: thin solid rgba(0,0,0,.12);
    background: #a80e00 !important;
    color: white !important;
}
>>>.v-data-table__wrapper {
    border-radius: 14px;
}

>>>.theme--light.v-data-table {
    border-radius: 14px !important;
    margin-bottom: 20px !important;
}

.textfieldSearch {
  width: 290px;
  display: -webkit-inline-box;
  margin-right: 20px;
}

.textfieldSelect {
  width: 280px;
  display: -webkit-inline-box;
  margin-right: 20px;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px), (min-width: 768px) and (max-width: 1024px)  {
  .textfieldSearch {
    width: 80vw;
    margin-top: 20px;
    display: -webkit-inline-box;
    margin-right: 20px;
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
  }
  .textfieldSelect {
    width: 80vw;
    margin-top: 20px;
    display: -webkit-inline-box;
    margin-right: 20px;
     border-radius: 30px !important;
    background: #ffffff !important;
    color: #a80e00 !important;
    border-color: #a80e00 !important;
    border-style: solid !important;
    border-width: thin !important;
  }
}

/* >>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/listReport/Listuser.vue